import { AdminClientMembers } from './AdminClientMembers';

export default AdminClientMembers;